"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxList = void 0;
var PropTypes = require("prop-types");
var React = require("react");
var Checkbox_1 = require("../Checkbox");
var ErrorMessage_1 = require("../ErrorMessage");
var HelpText_1 = require("../HelpText");
var CheckboxList = function (props) {
    var fieldsetAttributes = {
        className: 'form-group form-checkboxlist',
        id: props.id,
    };
    var inputName = props.name ? props.name : props.id;
    var headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    var _a = React.useState(props.label), labelChild = _a[0], setLabelChild = _a[1];
    var ErrorMessageComponent;
    var HelpTextComponent;
    if (typeof props.isValid === 'boolean' && props.isValid === false) {
        // Invalid
        fieldsetAttributes.className += ' is-invalid';
        fieldsetAttributes['aria-invalid'] = true;
        // Invalid with error message
        if (props.errormessage) {
            fieldsetAttributes['aria-describedby'] = props.id + "-errormessage";
            ErrorMessageComponent = (React.createElement(ErrorMessage_1.ErrorMessage, { id: props.id, message: props.errormessage }));
        }
    }
    else if (props.helptext) {
        fieldsetAttributes['aria-describedby'] = props.id + "-helptext";
        HelpTextComponent = (React.createElement(HelpText_1.HelpText, { id: props.id }, props.helptext));
    }
    var onChange = null;
    if (typeof props.onChange === 'function') {
        onChange = function (name, value, event) {
            var values = props.value;
            values[name] = value;
            // @ts-ignore
            props.onChange(inputName, values, event);
        };
    }
    React.useEffect(function () {
        var _a;
        if (props.headingTag && headings.includes(props.headingTag.toLowerCase())) {
            setLabelChild(React.createElement((_a = props.headingTag) === null || _a === void 0 ? void 0 : _a.toLowerCase(), null, props.label));
        }
        else if (props.isLabelHeading) {
            setLabelChild(React.createElement('h1', null, props.label));
        }
        else {
            setLabelChild(props.label);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.headingTag, props.isLabelHeading]);
    return (React.createElement("fieldset", __assign({}, fieldsetAttributes),
        React.createElement("legend", null, labelChild),
        HelpTextComponent,
        ErrorMessageComponent,
        React.createElement("div", { className: props.isValid ? '' : 'form-group-error' }, props.options && props.options.map(function (option) {
            var name = option.name ? option.name : option.value;
            var id = props.id + '-' + name;
            var checkboxAttributes = {
                ariaDescribedBy: props.id + "-helptext",
                checked: !!props.value[name],
                id: id,
                inline: props.inline,
                isInverted: props.isInverted,
                isValid: props.isValid,
                label: option.label,
                labelSecondary: option.labelSecondary,
                name: name,
                onChange: onChange,
                value: option.value,
            };
            return (React.createElement(Checkbox_1.Checkbox, __assign({}, checkboxAttributes, { key: id })));
        }))));
};
exports.CheckboxList = CheckboxList;
/* tslint:disable:no-string-literal */
exports.CheckboxList['defaultProps'] = {
    inline: false,
    isValid: true,
};
exports.CheckboxList['propTypes'] = {
    errormessage: PropTypes.string,
    headingId: PropTypes.string,
    headingTag: PropTypes.string,
    helptext: PropTypes.any,
    id: PropTypes.string.isRequired,
    inline: PropTypes.bool,
    isInverted: PropTypes.bool,
    isLabelHeading: PropTypes.bool,
    isValid: PropTypes.bool,
    label: PropTypes.string.isRequired,
    name: PropTypes.string,
    onChange: PropTypes.func,
    options: PropTypes.array.isRequired,
    value: PropTypes.object,
};
/* tslint:enable:no-string-literal */
